import { useState } from 'react'
import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'
import Icon from '../Icon'
import { Modal } from '../Modal'

const ModalConfirmWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(50)} 0;
`

const StyledContainer = styled.div`
  background-color: ${theme.colors.lightGrey};
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.3em;
  width: 100%;
`

const StyledCode = styled.div`
  font-size: 2em;
  font-style: italic;
  font-weight: bold;
  text-transform: uppercase;
`

const StyledCopyToClipboard = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  cursor: pointer;
`

const TeamCodeComponent = ({ team, teamCode: teamCodeFromProps }) => {
  const { teamCode: teamCodeFromTeam = '' } = team || {}
  const teamCode = teamCodeFromTeam || teamCodeFromProps || null
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (typeof navigator === 'undefined' || !navigator.clipboard) {
      return
    }

    try {
      await navigator.clipboard.writeText(teamCode)
      setCopied(true)
    } catch {
      // Do nothing if clipboard write is blocked.
    }
  }

  if (!teamCode) {
    return null
  }

  return (
    <>
      <StyledContainer>
        <StyledCode>{teamCode}</StyledCode>
        <StyledCopyToClipboard type="button" onClick={handleCopy}>
          <Icon iconSize={36} iconName="copy" color="teal" toolTipTitle={null} viewBox="0 0 32 32" />
        </StyledCopyToClipboard>
      </StyledContainer>
      {copied && (
        <Modal
          label="Copied to Clipboard"
          isShowBottomBar
          isOpen={copied}
          isShowSaveButton
          isHideCancel
          okText="Close"
          handleModalClose={() => setCopied(false)}
          handleModalSubmit={() => setCopied(false)}
        >
          <ModalConfirmWrapper>Team Code successfully copied to the clipboard.</ModalConfirmWrapper>
        </Modal>
      )}
    </>
  )
}

export default TeamCodeComponent
